module.exports = "./img/c05a50f343f3afdca3c10d2be87bd2d2.jpg";